import {View} from 'backbone';
import template     from 'common-views/data-history-form.ejs';
import constants from 'Constants.js';
import $ from 'jquery';
import util from 'util/Util.js';
import _ from 'lodash';

class DataHistoryModal extends View {

    initialize(opts){
        super.initialize(opts);
        this.gridElDataHistory = constants.PROP_MAIN_DATA_HISTORY;

        let colModelDataHistory = [
                {
                    name: 'field',
                    index: 'field',
                    cellattr: function (rowId, tv, rawObject, cm, rdata) { return 'style="white-space: normal;"' },
                    editable: false
                }
            ];

        let colNamesDataHistory = ['Field'];
        if(this.model.get('dataHistory')){
           let fieldColumns = this.model.get('dataHistory').FormInstance.Submission instanceof Array ? this.model.get('dataHistory').FormInstance.Submission : [this.model.get('dataHistory').FormInstance.Submission];
           let columnModel = {};
           let columnName = '';

           if(fieldColumns.length <= 3){
            colModelDataHistory[0].width = 700/(fieldColumns.length+1);
           }
           fieldColumns.forEach( (val, i) => {
                 columnName = util.formatExpressionShortDate(val['@date']) + ' </br> ' + val['@user'] + '</br> ' + val['@stage'] ;
                 colNamesDataHistory.push(columnName);
                 if(fieldColumns.length <= 3){
                    columnModel = {
                        name: 'col'+ (i+1),
                        index: 'col'+ (i+1),
                        cellattr: function (rowId, tv, rawObject, cm, rdata) { return 'style="white-space: normal;"' },
                        editable: false,
                        width: 700/(fieldColumns.length+1)
                     }
                }else{
                    columnModel = {
                        name: 'col'+ (i+1),
                        index: 'col'+ (i+1),
                        cellattr: function (rowId, tv, rawObject, cm, rdata) { return 'style="white-space: normal;"' },
                        editable: false
                     }
                }
                 colModelDataHistory.push(columnModel);
           });
        }

        this.model.set('colModelDataHistory', colModelDataHistory, {silent:true});
        this.model.set('colNamesDataHistory', colNamesDataHistory, {silent:true});

        this.firstColumnWidth = 350;

        $('body').append(this.$el);
    }

    renderDialog(resolve, reject){
            this.$el.html(template(this.model.toJSON()));
            this.delegateEvents();
            var self = this;
            const body = $('body');
            $( constants.DIALOG_ID ).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: 500,
                width: 750,
                minWidth: 750,
                minHeight: 200,
                maxWidth: body.width(),
                maxHeight: body.height(),
                modal: true,
                resizable: true,
                open: () => {
                    $(self.gridElDataHistory).closest('div.ui-dialog').append('<img id="modalResizeHandler" src="'+require("common/buttons/resize_handler.png")+'"/>');
                },
                resize: (ev, ui) => {
                    let dialog = $(constants.DIALOG_ID);
                    let grid = $(self.gridElDataHistory);
                    let width = dialog.width() - 30;
                    let height = dialog.height() - 40;


                    grid.jqGrid("setGridWidth", width, false);
                    grid.jqGrid("setGridHeight", height, false);
                },
                close: (ev, ui) => {
                    this.closeModal();
                },
                buttons: [
                    {
                        text: 'OK',
                        'class':'btn-select-item',
                        click: function() {
                            resolve('Ok');
                            self.closeModal();
                        }
                    }
                ]
            });

            $('div[role="dialog"]').draggable(constants.DEFAULT_DRAGGABLE_OPTIONS);
    }

    getDataHistoryProperties() {
        let self = this;
        return {
            maxHeight:'100%',
            shrinkToFit: true,
            cmTemplate: { sortable: false },
            colNames: this.model.get('colNamesDataHistory'),
            colModel: this.model.get('colModelDataHistory'),
            resizeStop: (width, index) => {

                let dialog = $(constants.DIALOG_ID);
                let grid = $(self.gridElDataHistory);

                let gridWidth = dialog.width() - 30;
                let height = dialog.height() - 40;
                grid.jqGrid('setGridWidth', gridWidth, false);
                grid.jqGrid("setGridHeight", height, false);
            }
        }
    }

    render() {
        return new Promise((resolve, reject) => {
            this.$el.empty();
            if (this.template) {
                this.$el.html(this.template(this.model.toJSON()));
            }
            this.renderDialog(resolve, reject);
            let self = this;
            let datahistoryGridObject = util.getGridObject(self, self.getDataHistoryProperties());
            $(self.gridElDataHistory).jqGrid(datahistoryGridObject);
            

            $("#gbox_propMainDataHistory").css({ 'margin': '15px 0 0 12px' });

            // PF-9876 Dashboard - Scrollbars are not always enabled in the Data History
            let dialog = $(constants.DIALOG_ID);

            let height = dialog.height() - 40;
            let width = dialog.width() - 30;
            $(self.gridElDataHistory).jqGrid("setGridHeight", height, false);
            $(self.gridElDataHistory).jqGrid("setGridWidth", width, false);

            dialog.css({'height' : dialog.height() + 40});
          
            let fields = [];
            if (self.model.get('dataHistory').FormInstance.Headers) {
                fields = self.model.get('dataHistory').FormInstance.Headers.Field instanceof Array ? self.model.get('dataHistory').FormInstance.Headers.Field : [self.model.get('dataHistory').FormInstance.Headers.Field];
            }

            let submissions = self.model.get('dataHistory').FormInstance.Submission instanceof Array ? self.model.get('dataHistory').FormInstance.Submission : [self.model.get('dataHistory').FormInstance.Submission];

            const fieldLen = fields.length < 15 ? 15 : fields.length;

            let colName = '';
            let newRow = {};
            let type = '';
            for (let i = 0; i < fieldLen; i++) {
                let formatCell = [];
            
                if (fields[i]) {
                    type = fields[i]['@type'];
                    newRow = {
                        'field': fields[i]['#text']
                    };
                    submissions.forEach( (val, j) => {
                        const cell = val.Field instanceof Array ? val.Field : [val.Field];
                        //value can come from tables inside the value parameter or directly from other controls
                        let found = _.find(cell, {'@id':(i+1).toString()});
                        let value, setValue = '';
                        if (found){
                            value = found.value ? found.value : found;
                            if (value instanceof Array){
                                // it is a table with several values, so format and concat them
                                let parsedValue = '';
                                value.forEach( (aValue, aIndex) =>{
                                   // if it's the first line, don't add anything.  else, add a br and the new value
                                   // and for the value, if it's a date, parse it.  If not, check if there is a value.  If so, add it.  Else add a blank space
                                    parsedValue = (parsedValue? parsedValue + '<br>': '') + (type === 'date' && aValue['#text'] ? util.formatExpressionShortDate(aValue['#text']) : (aValue['#text']? aValue['#text'] : ''));
                                });
                                setValue = parsedValue;
                            } else {
                                setValue = type === 'date' && value['#text'] ? util.formatExpressionShortDate(value['#text']) : (value['#text'] || '');
                            }

                            if(j > 0){    
                                if(setValue !== newRow['col' + j]){
                                    formatCell.push( j + 1 );
                                }        
                            }
                        }

                        newRow['col'+(j+1)] = setValue;
                    });
                    $(self.gridElDataHistory).addRowData(i, newRow);
                }
                else {
                    newRow = {
                        'field': ''
                    };
                    $(self.gridElDataHistory).addRowData(i, newRow);
                }

                if(formatCell && formatCell.length){
                    const lastRow = $(self.gridElDataHistory).find(">tbody>tr.jqgrow:last");
                    _.each(formatCell, (c) =>{
                        const cell = lastRow.find("td:eq(" + c + ")");
                        cell.css("background-color", "#E2E6FF");
                    });
                }
            }
            
            $(this.gridElDataHistory + " tr.jqgrow:odd").css("background", "#DDDDDC");
        });
    }

    closeModal() {
        $( constants.DIALOG_ID ).dialog("destroy").remove();
    }
}
export default DataHistoryModal;
